import React, { memo, useMemo } from 'react';
import { HeaderType } from './Table';
import styles from './table.module.scss';
import Button from 'components/Button/Button';
import commonStyles from 'assets/styles/common.module.scss'
import { ErrorsType, globalErrorKey } from 'components/Form/models';
import { RowContainer } from 'components/Layout';
import { FieldMessage } from 'components/Form/addons';

type Props = {
	headers: HeaderType[]
	fields: React.ReactElement[]
	errorsMap: ErrorsType
	DraggableHandle?: JSX.Element
	isAnyRowDeletable: boolean
	rowIsDeletable: boolean
	index: number
	onDelete: (index: number) => void
}

export const TableRow = ({ headers, fields, errorsMap, DraggableHandle, isAnyRowDeletable, rowIsDeletable, index, onDelete }: Props) => {
	const content = useMemo(
		() => {
			return headers.map((header, index) => (
				<div key={index} className={styles.cell} style={{ flex: header.size }}>
					{fields[index]}
				</div>
			))
		},
		[fields, headers]
	)

	return (
		<>
			<div style={{ display: 'flex' }}>
				{DraggableHandle}
				{content}
				{isAnyRowDeletable &&
					<div className={`${styles.cell} ${rowIsDeletable ? '' : commonStyles.hidden_no_height}`}>
						<Button
							text='i18n.label.x'
							color='destructive'
							onClick={onDelete?.bind(null, index)}
						/>
					</div>
				}
			</div>
			{errorsMap && errorsMap[globalErrorKey] &&
				<RowContainer justifyContent='flex-end'>
					<FieldMessage error={errorsMap[globalErrorKey]} />
				</RowContainer>
			}
		</>
	)
}

export default memo(TableRow)
